import busVue from "@/common/utils/busVue";
import {
  localStorage
} from '@src/common/lib/storage'
import axios from 'axios';

const mixin = {

  data() {
    return {
      // imosSdk: window.systemConfig.IMOSSDK,
      // imosSdk: imosSdk,
      ctx: null,
      recorder: null,
      showIsFull: false,
      chunks: [],
      checkVideo: [],
      tableLoding: false,
      Videopage: {
        total: 0,
        pageNo: 1,
        pageSize: 15,
      },
      tableData: [],
      videoSerch: {
        account: "",
        name: "",
      },
      videoForm: {
        name: "",
        id: "",
        text: "",
      },
      dialogVideo: false,
      buttonLoding: false
    }
  },
  methods: {
    queryPlatSystemList() {
      return new Promise((resolve) => {
        this.$fetch("/cms/accessportal/queryPlatSystemListApi.json", {
          pageNum: 1,
          pageSize: 100,
          systemId: "200000014",
        }).then((res) => {
          if (res.success) {
            resolve(res.returnObj.list[0])
          }
        });
      })
    },
    //插件登录
    login() {
      return new Promise((resolve) => {
        console.log('插件登录', imosSdk)
        let password, username, ipaddr, port, loginResult;
        this.queryPlatSystemList().then((res) => {
          password = res.password;
          username = res.userName;
          ipaddr = res.ip;
          port = res.port;
          this.$fetchVideo('/VIID/login/v2')
            .then(res => {
              var accessCode = res.AccessCode;
              var md1 = forge.md.md5.create(); //md5
              var md2 = forge.md.md5.create(); //md5
              md1.update(password); //md5
              var passwordMd5 = md1.digest().toHex(); //md5
              var base64Username = window.btoa(username);
              var loginSignatureTemp = base64Username + accessCode + passwordMd5;
              md2.update(loginSignatureTemp); //md5
              console.log(md1, md2, '---0md1')
              var loginSignature = md2.digest().toHex(); //md5
              var data = {
                UserName: username,
                AccessCode: accessCode,
                LoginSignature: loginSignature,
              };
              this.$fetchVideo('/VIID/login/v2', data)
                .then((r) => {
                  loginResult = r.ErrCode;
                  console.log(r, loginResult, r.ErrCode, '=====r')
                  resolve(loginResult)
                  switch (
                    loginResult //判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
                  ) {
                    case 50004:
                      this.$message.error("密码错误");
                      break;
                    case 12351:
                      this.$message.error("用户不存在");
                      break;
                    case undefined:
                      window.token = r.AccessToken;
                      this.initImosSdk(ipaddr, window.token, 9, "/imosSdk.html", true)
                      break;
                  }
                })
              // .catch(function (e) {
              //   this.$message.error("服务器连接异常");
              //   console.log(e);
              // });
            })
            .catch(function (error) {
              // this.$message.error("服务器连接异常");
              console.log(error);
            });
        })
      })

      // console.log("login");
      // let password = "admin_123";
      // let username = "loadmin";
      // let ipaddr = "192.169.15.33";

    },
    //插件初始化
    initImosSdk(ip, token, num = 9, htmlUrl, keepAlive) {
      imosSdk
        .init(ip, token, num, htmlUrl, true)
        .then(function (res) {
          console.log("登录成功", res)
          // this.$message.error("登录成功");
        })
        .catch(function (err) {
          console.log("失败", err);
          // this.$message.error("调用失败" + err);
        });
    },
    // 视频直播id向后台发送axios
    vpdAxios() {
      if (this.axiosTimer) {
        clearInterval(this.axiosTimer);
      }
      this.axiosTimer = setInterval(() => {
        // || localStorage.getString('NETWORK_TYPE') == "CLOUD"
        if (!this.deviceInfo || !this.deviceInfo.streamId) {
          return false
        }
        let params = {
          streamId: this.deviceInfo.streamId,
          type: this.deviceInfo.videoType == 'back' ? "2" : "1"
        }
        this.$fetch(this.$api.common.video.vpdTime, params).then((res) => {});
      }, this.vpnTime * 500);

    },
    //判断是否有权限显示播放器按钮
    showTipIcon(val) {
      let isHave = this.isBarList.indexOf(val)
      return isHave > -1 ? true : false
    },
    //video控制条的按钮回调
    iconClick(type) {
      //  "抓拍":1,  "分享":2, "全屏":3,
      if (type == 1) {
        // 抓拍
        // this.captureVideo();
        //抓拍 -宇视
        this.captureVideoNew()
      } else if (type == 2) {
        // 分享
        this.fullScreenVideo(1)
        // busVue.$emit("shareVideo", this.deviceInfo);
        this.showShareVideo(this.deviceInfo);
      } else if (type == 3) {
        // 放大-取消
        if (this.zoomStatus) {
          this.buttonIconList[3].name = '放大'
          this.vW = 100
          this.vH = 100
          this.moveXDistance = 0
          this.moveYDistance = 0
          this.marginTop = 0
          this.marginLeft = 0
        } else {
          this.buttonIconList[3].name = '取消放大'
        }
        let eleID = "video_" + this.wnd;
        const el = document.getElementById(eleID);
        el.classList.toggle('isZoomIn')
        this.changeZoomIn();
      } else if (type == 4) {
        // 全屏
        this.showIsFull = true
        this.fullScreenVideo();
      } else if (type == 5) {
        // 视频信息
        this.fullScreenVideo(1)
      } else if (type == 6) {
        // 设置流码
        this.fullScreenVideo(1)
        console.log("设置视频码流")
      } else if (type == -1) {
        // 自适应  铺满窗口
        let eleID = "video_" + this.wnd;
        const el = document.getElementById(eleID);
        el.classList.toggle('isFull')

      } else if (type == -2) {
        // 本地录像
        this.startVideoRecord()
      }
    },
    showShareVideo(data) {
      Object.keys(this.videoSerch).forEach(
        (key) => (this.videoSerch[key] = "")
      );
      Object.keys(this.videoForm).forEach((key) => (this.videoForm[key] = ""));
      this.Videopage.pageNo = 1;
      this.Videopage.pageSize = 15;
      this.Videopage.total = 0;
      this.videoSearchDg(2);
      this.checkVideo = [];
      this.videoForm.name = data.name;
      this.videoForm.id = data.deviceId || data.thirdCameraId;
      this.videoForm.text = "";
      this.tableData = [];
      this.dialogVideo = true;
    },
    handleSelectionChange(item) {
      // 多选
      this.checkVideo = item
    },
    VideosizeChange(item) {
      this.Videopage.pageSize = item;
      this.videoSearchDg(1);
    },
    VideopageChange(item) {
      this.Videopage.pageNo = item;
      this.videoSearchDg(1);
    },
    videoSearchDg(type) {
      // 收索分享人员+提交+重置
      if (type == 3) {
        // 提交
        if (!this.checkVideo.length) {
          this.$message.warning("人员未选中，请选中后提交");
          return;
        }
        this.buttonLoding = true;
        let params = {
          deviceId: this.videoForm.id,
          description: this.videoForm.text,
          accountNumberList: this.checkVideo.map(el => {
            return el.accountNumber
          })
        };
        this.$fetch(this.$api.common.video.shareVideo, params).then((res) => {
          if (res.success) {
            this.$message.success("分享成功");
            this.dialogVideo = false;
          } else {
            this.$message.error(res.msgContent);
          }
          setTimeout(() => {
            this.buttonLoding = false;
          }, 500);
        })
      } else {
        // 查询人员
        this.tableLoding = true;
        if (type == 2) {
          Object.keys(this.videoSerch).forEach(
            (key) => (this.videoSerch[key] = "")
          );
        }
        let param = {
          accountType: 1,
          pageNo: this.Videopage.pageNo,
          pageSize: this.Videopage.pageSize,
          accountNumber: this.videoSerch.account,
          nickName: this.videoSerch.name,
        };
        this.$fetch(this.$api.common.queryAccountList, param).then((res) => {
          if (res.success) {
            let data = res.returnObj.list || [];
            this.tableData = [...data];
            this.Videopage.total = res.returnObj.total;
          } else {
            this.$message.error(res.msgContent);
          }
          setTimeout(() => {
            this.tableLoding = false;
          }, 300);
        });
      }
    },
    // 录像1.1
    startVideoRecord() {
      console.log(this.deviceInfo)
      const canvas = document.createElement('canvas');
      canvas.width = 360;
      canvas.height = 270;
      const frameRate = 60;
      const encodeType = 'video/webm;codecs=vp8';
      // const encodeType = 'video/mp4;codecs=avc1.42c01e'
      this.chunks = [];
      this.ctx = canvas.getContext('2d');
      this.ctx.fillStyle = 'deepskyblue';
      this.ctx.fillRect(0, 0, 360, 270);
      // 创建MediaRecorder，设置媒体参数
      const stream = canvas.captureStream(frameRate);
      this.recorder = new MediaRecorder(stream, {
        mimeType: encodeType
      });
      this.showRecord = true
      // 收集录制数据
      this.recorder.ondataavailable = e => {
        // console.info('chunk', e.data);
        if(e.data && e.data.size){
          this.chunks.push(e.data);

        }
      };
      // 开始录像
      this.recorder.start(10);
      this.drawFrame();
    },
    drawFrame() {
      this.ctx.drawImage(this.$refs.video, 0, 0, 360, 270);
      this.frameId = requestAnimationFrame(this.drawFrame);
    },
    // 取消录像
    cancelVideoRecord() {
      this.showRecord = false
      this.recorder.stop();
    },
    // 暂停录像--继续录像
    pauseVideoRecord() {
      if (this.videoRecordPause) {
        this.recorder.resume();
      } else {
        this.recorder.pause();
      }
      this.videoRecordPause = !this.videoRecordPause
    },
    // 关闭录像
    stopVideoRecord() {
      this.showRecord = false
      this.recorder.stop();
      cancelAnimationFrame(this.frameId);
      this.download();
    },
    // 视频下载
    download() {
      const blob = new Blob(this.chunks);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // link.download = new Date().getTime() + '.mp4';
      link.download = (this.deviceInfo.name || new Date().getTime()) + '.mp4';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    //9-27 新抓拍
    captureVideoNew() {
      imosSdk.playCatch(this.wnk, (result) => {
        if (result.ErrCode === 0) {
          console.log('成功');
          this.downloadImage(result.Img);
          this.$message({
            message: "抓拍成功，正在下载到本地",
            type: "success",
          });
        } else {
          this.$message({
            message: result.ErrMsg,
            type: "error",
          });
          console.log('失败：' + result.ErrMsg);
        }
      }, 'image/jpeg')
    },
    // 一键抓拍
    captureVideo() {
      const param = {
        deviceId: this.deviceInfo.deviceId || this.deviceInfo.thirdCameraId,
      };
      // 判断是否是预案执行，如果是添加执行记录id
      let lastIndex = window.location.href.lastIndexOf("#") + 2
      if (window.location.href.substr(lastIndex, 22) == 'reserve/reserveProcess') {
        param.emergencyRecordCode = window.location.href.split('=')[1]
      }
      this.buttonIconList[0].icon = "el-icon-loading"
      this.buttonIconList[0].name = "抓拍中"
      this.$fetch(this.$api.common.video.localSnap, param).then((res) => {
        if (res.success) {
          this.downloadImage(res.returnObj.img_url);
          this.$message({
            message: "抓拍成功，正在下载到本地",
            type: "success",
          });
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
        setTimeout(() => {
          this.buttonIconList[0].icon = "el-icon-camera-solid"
          this.buttonIconList[0].name = "一键抓拍"
        }, 500);
      });
    },
    downloadImage(imgsrc) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "snap_" + new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    // 全屏显示-退出全屏
    fullScreenVideo(full) {
      let eleID = "player_" + this.wnd
      const el = document.getElementById(eleID);
      // const el = document.querySelector(eleID);
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (isFull) {
        this.showIsFull = false
        //退出
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        if (full) return
        // 放大
        (el.requestFullscreen && el.requestFullscreen()) ||
        (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
        (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
        (el.msRequestFullscreen && el.msRequestFullscreen());
      }
    },
    // 子主码流切换
    switchVideoFn(val) {
      // 录像放暂支持切换码流
      if (this.deviceInfo.videoType == 'back') {
        return
      }
      this.streamType = !this.streamType
      this.$message.info("开始切换" + (this.streamType ? '主码流' : '子码流') + ",请稍后")
      this.fullScreenVideo(1)
      // 1码流 false主码流MAIN true子码流 SUB
      if (this.playUrl) {
        this.$emit("checkType", {
          deviceInfo: this.deviceInfo,
          index: this.wnd,
          type: !this.streamType ? 'SUB' : 'MAIN'
          // type: this.streamType ? 'SUB' : 'MAIN'
        })
        return
      }
      this.$message.warning("暂无视频,稍后操作")
    },
    // 双击放大
    toggleFullScreen() {
      console.log(this.deviceInfo)
      if (this.showRecord) {
        this.$message.warning("视频录制中，稍后操作");
        return false
      }
      let eleID = "player_" + this.wnd;
      const el = document.getElementById(eleID).parentNode;
      if (this.playUrl) {
        if (this.streamType && el.className.indexOf('full-screen') == -1) {
          // 录像放大不支持切换码流
          // if (this.deviceInfo.videoType != 'back') {
          //   this.$emit("checkType", {
          //     deviceInfo: this.deviceInfo,
          //     index: this.wnd,
          //     type: 'MAIN'
          //   })
          //   console.log("放大")
          // }

          setTimeout(() => {
            el.classList.toggle('full-screen')
          }, 500);
        } else {
          el.classList.toggle('full-screen')
        }
      }
    },
    // 暂停播放云视频回调--暂时up
    selectVideo(id, type) {
      return new Promise((resolve, reject) => {
        //暂停：pause，恢复：resume
        this.$fetch(
            this.$api.common.video.playOrPauseVideo, {
              streamId: id,
              type: type
            })
          .then(res => {
            if (res.success) {
              resolve(res)
            } else {
              reject(res.msgContent);
            }
          })
      })
    },
    // 重新请求视频流--暂时up
    reloadVideo() {
      this.deviceInfo.getNum = this.deviceInfo.getNum > 0 ? this.deviceInfo.getNum += 1 : 1
      this.deviceInfo.streamType = ''
      this.$emit('reloadVideo', this.wnd, this.deviceInfo.getNum || type, this.deviceInfo);
      return
    },
  }
}

export default mixin
